import { Component, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UrlSettingsCore } from '../../configuration/url-settings-core';
import { HelpersService } from '../../services/helpers.service';
import { Subscription } from 'rxjs';
import { UtenteLoggato } from 'src/app/common/models/utente-loggato';
import { ResponsiveService } from '../../services/responsive.service';
import { AppData } from 'src/app/data-store';

@Component({
  selector: '[main_responsive_header]',
  templateUrl: './responsive-header.component.html',
  styleUrls: ['./responsive-header.component.css']
})
export class ResponsiveHeaderComponent implements OnInit, OnDestroy {
  urlWelcomeBoard: string = UrlSettingsCore.URL_VISUALIZZA_WELCOME_BOARD;
  userdata: UtenteLoggato;
  subscription: Subscription;
  showMenu = false;
  headerFixed = false;
  @Input() menuSezioni;
  @HostListener('window:scroll', ['$event']) onScrollEvent($event) {
    if(window.scrollY > 0) {
      this.headerFixed = true;
    } else {
      this.headerFixed = false;
    }

}
  constructor(
    private helpers: HelpersService,
    private responsive: ResponsiveService,
  ) { }

  ngOnInit(): void {
    if(!AppData.getInstance().loggedUser) {
      this.subscription = this.helpers.getLoggedUserData().subscribe(response => {
        this.userdata = response;
      });
    } else {
      this.userdata = AppData.getInstance().loggedUser;
    }
    this.responsive.sidebarState.subscribe(
      isOpen => this.showMenu = isOpen
    )
  }

  onMenuClick() {
    this.showMenu = !this.showMenu;
    // if(this.showMenu) {
    //   this.responsive.openSidebar();
    // } else {
    //   this.responsive.closeSidebar();
    // }
  }

  closeSidebar() {
    this.responsive.closeSidebar();
  }

  ngOnDestroy(): void {
      if(this.subscription) {
        this.subscription.unsubscribe();
      }
  }

  onSideMenuEvent() {
    this.responsive.closeSidebar();
  }
}
